export default {
  FETCH_CONTENT_TAGS_START: 'FETCH_CONTENT_TAGS_START',
  FETCH_CONTENT_TAGS_SUCCESS: 'FETCH_CONTENT_TAGS_SUCCESS',
  FETCH_CONTENT_TAGS_FAILURE: 'FETCH_CONTENT_TAGS_FAILURE',
}
